import { defineComponent as I, ref as x, provide as b, h as v } from "vue";
import w from "./ghl-ui.es984.js";
import { formInjectionKey as j, formItemInstsInjectionKey as S } from "./ghl-ui.es985.js";
import M from "./ghl-ui.es842.js";
import g from "./ghl-ui.es843.js";
import O from "./ghl-ui.es986.js";
import { keysOf as y } from "./ghl-ui.es899.js";
var P = globalThis && globalThis.__awaiter || function(o, d, n, r) {
  function u(s) {
    return s instanceof n ? s : new n(function(f) {
      f(s);
    });
  }
  return new (n || (n = Promise))(function(s, f) {
    function p(t) {
      try {
        i(r.next(t));
      } catch (l) {
        f(l);
      }
    }
    function e(t) {
      try {
        i(r.throw(t));
      } catch (l) {
        f(l);
      }
    }
    function i(t) {
      t.done ? s(t.value) : u(t.value).then(p, e);
    }
    i((r = r.apply(o, d || [])).next());
  });
};
const B = Object.assign(Object.assign({}, g.props), { inline: Boolean, labelWidth: [Number, String], labelAlign: String, labelPlacement: {
  type: String,
  default: "top"
}, model: {
  type: Object,
  default: () => {
  }
}, rules: Object, disabled: Boolean, size: String, showRequireMark: {
  type: Boolean,
  default: void 0
}, requireMarkPlacement: String, showFeedback: {
  type: Boolean,
  default: !0
}, onSubmit: {
  type: Function,
  default: (o) => {
    o.preventDefault();
  }
}, showLabel: {
  type: Boolean,
  default: void 0
}, validateMessages: Object }), T = I({
  name: "Form",
  props: B,
  setup(o) {
    const { mergedClsPrefixRef: d } = M(o);
    g("Form", "-form", w, O, o, d);
    const n = {}, r = x(void 0), u = (e) => {
      const i = r.value;
      (i === void 0 || e >= i) && (r.value = e);
    };
    function s(e, i = () => !0) {
      return P(this, void 0, void 0, function* () {
        yield new Promise((t, l) => {
          const h = [];
          for (const c of y(n)) {
            const m = n[c];
            for (const a of m)
              a.path && h.push(a.internalValidate(null, i));
          }
          Promise.all(h).then((c) => {
            if (c.some((m) => !m.valid)) {
              const m = c.filter((a) => a.errors).map((a) => a.errors);
              e && e(m), l(m);
            } else
              e && e(), t();
          });
        });
      });
    }
    function f() {
      for (const e of y(n)) {
        const i = n[e];
        for (const t of i)
          t.restoreValidation();
      }
    }
    return b(j, {
      props: o,
      maxChildLabelWidthRef: r,
      deriveMaxChildLabelWidth: u
    }), b(S, { formItems: n }), Object.assign({
      validate: s,
      restoreValidation: f
    }, {
      mergedClsPrefix: d
    });
  },
  render() {
    const { mergedClsPrefix: o } = this;
    return v("form", { class: [
      `${o}-form`,
      this.inline && `${o}-form--inline`
    ], onSubmit: this.onSubmit }, this.$slots);
  }
});
export {
  T as default,
  B as formProps
};
